import React from "react";

import Button from "@mui/material/Button";
import styles from "./app-button.style";
import "./app-button.css";

interface AppButtonProps {
  label: string;
  onClick: () => void;
}

const AppButton = (props: AppButtonProps) => {
  const { label, onClick, ...other } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={[
        styles.button,
        {
          ":hover": styles.hover,
        },
      ]}
    >
      {label}
    </Button>
  );
};

export default AppButton;
